<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.3844 28.3841L28.3844 33.3841C28.1498 33.6186 27.8317 33.7504 27.5 33.7504C27.1683 33.7504 26.8502 33.6186 26.6156 33.3841C26.3811 33.1495 26.2493 32.8314 26.2493 32.4997C26.2493 32.168 26.3811 31.8499 26.6156 31.6153L29.4828 28.7497H7.50001C7.16849 28.7497 6.85054 28.618 6.61612 28.3836C6.3817 28.1492 6.25001 27.8312 6.25001 27.4997C6.25001 27.1682 6.3817 26.8503 6.61612 26.6158C6.85054 26.3814 7.16849 26.2497 7.50001 26.2497H29.4828L26.6156 23.3841C26.3811 23.1495 26.2493 22.8314 26.2493 22.4997C26.2493 22.168 26.3811 21.8499 26.6156 21.6153C26.8502 21.3808 27.1683 21.249 27.5 21.249C27.8317 21.249 28.1498 21.3808 28.3844 21.6153L33.3844 26.6153C33.5006 26.7314 33.5928 26.8693 33.6557 27.021C33.7186 27.1728 33.751 27.3355 33.751 27.4997C33.751 27.664 33.7186 27.8266 33.6557 27.9784C33.5928 28.1301 33.5006 28.268 33.3844 28.3841ZM11.6156 18.3841C11.8502 18.6186 12.1683 18.7504 12.5 18.7504C12.8317 18.7504 13.1498 18.6186 13.3844 18.3841C13.6189 18.1495 13.7507 17.8314 13.7507 17.4997C13.7507 17.168 13.6189 16.8499 13.3844 16.6153L10.5172 13.7497H32.5C32.8315 13.7497 33.1495 13.618 33.3839 13.3836C33.6183 13.1492 33.75 12.8312 33.75 12.4997C33.75 12.1682 33.6183 11.8503 33.3839 11.6158C33.1495 11.3814 32.8315 11.2497 32.5 11.2497H10.5172L13.3844 8.38409C13.6189 8.14954 13.7507 7.83142 13.7507 7.49972C13.7507 7.16801 13.6189 6.84989 13.3844 6.61534C13.1498 6.38079 12.8317 6.24902 12.5 6.24902C12.1683 6.24902 11.8502 6.38079 11.6156 6.61534L6.61563 11.6153C6.49941 11.7314 6.40721 11.8693 6.34431 12.021C6.2814 12.1728 6.24902 12.3354 6.24902 12.4997C6.24902 12.664 6.2814 12.8266 6.34431 12.9784C6.40721 13.1301 6.49941 13.268 6.61563 13.3841L11.6156 18.3841Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsArrowLeftRight'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  }
})
</script>
